import { createRouter, createWebHashHistory } from "vue-router";
import { installNavigationFeedback } from "../util/navigationFeedback";
import { checkForAppUpdate } from "../util/appUpdates";
import { ElMessage, ElMessageBox } from "element-plus";
import store from "../store/index";
import { getCurrentEntityInfo, getProfile } from "../servies/classPostNewApi";
import i18n from "../lang/i18n";
import {
    SUB_USER_LOGIN_PATH,
    canSubUserAccessPath,
    getSubUserLandingPath,
    isPendingSubUserLogin,
    isSubUserSession,
    shouldSkipSubUserRouteGuard
} from "../common/subUser";

function getAccessToken() {
    try {
        if (!sessionStorage.loginData || sessionStorage.loginData === "null") {
            return "";
        }
        const loginData = JSON.parse(sessionStorage.loginData);
        return (loginData && loginData.accessToken) || "";
    } catch (e) {
        return "";
    }
}

/** 路由切换时异步刷新用户信息缓存，不阻塞导航 */
function refreshProfileCache() {
    if (!getAccessToken()) return;
    getProfile({})
        .then(res => {
            if (res && res.data) {
                const profile = JSON.stringify(res.data);
                sessionStorage.profile = profile;
                sessionStorage.setItem("profile", profile);
            }
        })
        .catch(() => {});
}

const login = () =>
    import("@/components/login"); //登录页
const register = () =>
    import("@/components/register"); //注册页
const getReady = () =>
    import("@/components/getReady"); //注册完成页
const reSetPass = () =>
    import("@/components/other/reSetPass"); //忘记密码
const mailboxSuccess = () =>
    import("@/components/mailboxSuccess"); //发送邮箱页
const completeAccountPhone = () =>
    import("@/components/completeAccountPhone"); //完善账户信息，手机
const completeAccountEmail = () =>
    import("@/components/completeAccountEmail"); //完善账户信息，邮箱
const completeAccountSuccess = () =>
    import("@/components/completeAccountSuccess"); //注册成功
const completeAccountFailed = () =>
    import("@/components/completeAccountFailed"); //注册失败

const index = () =>
    import("../components-new/index");
//首页
const home = () =>
    import("../components-new/Home");

const ApplyKyc = () =>
    import("../components-new/ApplyKyc");
const KycList = () =>
    import("../components-new/kyc/List");
const Payment = () =>
    import("../components-new/Payment");
const PoboPayerManagement = () =>
    import("../components-new/payment/pobo/PoboPayerManagement");
const PoboPayerForm = () =>
    import("../components-new/payment/pobo/PoboPayerForm");
const AccountTransfer = () =>
    import("../components-new/AccountTransfer");
const BulkPayment = () =>
    import("../components-new/payment/BulkPayment");
const SubBulkPayment = () =>
    import("../components-new/payment/SubBulkPayment");
const Payee = () =>
    import("../components-new/Payee_new");
const PayeeAccount = () =>
    import("../components-new/payee/PayeeAccount");
const BatchPayeeImport = () =>
    import("../components-new/payee/batchImport/BatchPayeeImport");
const PayeeAccountByUser = () =>
    import("../components-new/payee/PayeeAccountByUser");
const MyShop = () =>
    import("../components-new/payee/Myshop");

const MyShopOther = () =>
    import("../components-new/payee/MyshopOther");
const BindShop = () =>
    import("../components-new/payee/BindShop");
const BindShopVinted = () =>
    import("../components-new/payee/BindShopVinted");
const ShopOrderList = () =>
    import("../components-new/payee/ShopOrderList");
const ShopOrderListByEntity = () =>
    import("../components-new/payee/ShopOrderListByEntity");
const TradeSeach = () =>
    import("../components-new/tradeSeach/index");
const TradeDetail = () =>
    import("../components-new/tradeSeach/TradeDetail");
const TradeReceipt = () =>
    import("../components-new/tradeSeach/TradeReceipt");
const BalanceDetail = () =>
    import("../components-new/tradeSeach/BalanceDetail");
const CashDetail = () =>
    import("../components-new/tradeSeach/CashDetail");
const batchDetail = () =>
    import("../components-new/tradeSeach/batchDetail");
const MyBill = () =>
    import("../components-new/tradeSeach/MyBill");
const PayeeIndex = () =>
    import("../components-new/payee/index");
const ApplyShopAccount = () =>
    import("../components-new/payee/ApplyShopAccount");
const BindOther = () =>
    import("../components-new/payee/BindOther");
const BusinessOpenRecord = () =>
    import("../components-new/payee/BusinessOpenRecord.vue");
const BusinessOpenRecordDetail = () =>
    import("../components-new/payee/BusinessOpenRecordDetail.vue");
const ShopListVinted = () =>
    import("../components-new/payee/ShopListVinted.vue");
const BatchApplyVa = () =>
    import("../components-new/payee/BatchApplyVa.vue");

const CreatVa = () =>
    import("../components-new/payee/creatVa");
const PartnerFile = () =>
    import("@/components/partnerFile");


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        //注册后进入倒计时页面
        {
            path: "/getReady",
            name: "注册完成页",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "注册完成页",
            },
            component: getReady,
            children: [],
        },
        //邀请注册
        {
            path: "/inviteRegister/:id",
            name: "register",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "注册",
            },
            component: register,
            children: [],
        },
        //注册发送邮件
        {
            path: "/mailboxSuccess",
            name: "注册发送邮件",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "注册发送邮件",
            },
            component: mailboxSuccess,
            children: [],
        },
        //完善账户信息，手机
        {
            path: "/completeAccountPhone",
            name: "完善账户信息",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "完善账户信息，手机",
            },
            component: completeAccountPhone,
            children: [],
        },
        //完善账户信息，邮箱
        {
            path: "/completeAccountEmail",
            name: "完善账户信息邮箱",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "完善账户信息，邮箱",
            },
            component: completeAccountEmail,
            children: [],
        },
        //注册成功
        {
            path: "/completeAccountSuccess",
            name: "注册成功",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "注册成功",
            },
            component: completeAccountSuccess,
            children: [],
        },
        //注册失败
        {
            path: "/completeAccountFailed",
            name: "注册失败",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "注册成功",
            },
            component: completeAccountFailed,
            children: [],
        },
        {
            path: "/applyKyc",
            name: "kyc",
            meta: {
                loginAuth: true, // 需要登录验证的页面添加meta属性
                title: "kyc",
            },
            component: ApplyKyc,
            children: [],
        },

        {
            path: "/home",
            name: localStorage.LANG == "zh-CN" ? undefined : "首页一览",
            meta: {
                loginAuth: false,
                title: "",
                children: [{
                    path: "/home",
                    name: "首页一览",
                },],
            },
            component: index,
            children: [
                //登录
                {
                    path: "/login",
                    name: "登录",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "登录",
                    },
                    component: login,
                    children: [],
                },
                {
                    path: SUB_USER_LOGIN_PATH,
                    name: "子用户登录",
                    meta: {
                        loginAuth: false,
                        title: "子用户登录",
                    },
                    component: login,
                    children: [],
                },
                {
                    path: "/registerFile",
                    name: "注册协议",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "注册协议",
                    },
                    component: () =>
                        import("@/components/registerFile"),
                    children: [],
                },
                {
                    path: "/partnerFile",
                    name: "合作伙伴名单",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "合作伙伴名单",
                    },
                    component: () =>
                        import("@/components/partnerFile"),
                    children: [],
                },
                //注册
                {
                    path: "/register",
                    name: "注册",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "注册",
                    },
                    component: register,
                    children: [],
                },
                //忘记密码
                {
                    path: "/resetPwd",
                    name: "忘记密码",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "忘记密码",
                    },
                    component: () =>
                        import("@/components/resetPwd"),
                    children: [],
                },
                //首页
                {
                    path: "/home",
                    meta: {
                        title: "首页一览",
                        show: true,
                    },
                    name: localStorage.LANG == "zh-CN" ? "首页一览" : "home", //修复语言切换时name引起的router does not exist
                    component: home,
                },
                {
                    path: "/creatVa",
                    name: "creatVa",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "creatVa",
                    },
                    component: CreatVa,
                    children: [],
                },
                {
                    path: "/batchApplyVa",
                    name: "batchApplyVa",
                    meta: {
                        loginAuth: true,
                        title: "batchApplyVa",
                    },
                    component: BatchApplyVa,
                    children: [],
                },
                // 公告详情
                {
                    path: "/noticeDetail",
                    meta: {
                        title: "公告详情",
                        show: true,
                    },
                    name: localStorage.LANG == "zh-CN" ? "公告详情" : "notice", //修复语言切换时name引起的router does not exist
                    component: () =>
                        import("@/components-new/noticeCenter/noticeDetail/noticeDetail"),
                },
                {
                    path: "/accountList",
                    name: "我的账户",
                    meta: {
                        loginAuth: true,
                        title: "我的账户",
                    },
                    component: () =>
                        import("@/components-new/account/index"),
                    children: [],
                },
                {
                    path: "/accountList/withdraw",
                    name: "立即提现",
                    meta: {
                        loginAuth: true,
                        title: "立即提现",
                    },
                    component: () =>
                        import("@/components-new/account/withdraw"),
                    children: [],
                },
                {
                    path: "/accountList/withdrawAccount",
                    name: "提现账户列表",
                    meta: {
                        loginAuth: true,
                        title: "提现账户列表",
                    },
                    component: () =>
                        import("@/components-new/account/withdrawAccount"),
                    children: [],
                },
                {
                    path: "/accountList/addWithdrawAccount",
                    name: "添加提现账户",
                    meta: {
                        loginAuth: true,
                        title: "添加提现账户",
                    },
                    component: () =>
                        import("@/components-new/account/addWithdrawAccount"),
                    children: [],
                },
                {
                    path: "/payment",
                    name: "payment",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "payment",
                    },
                    component: Payment,
                    children: [],
                },
                {
                    path: "/payment/payer-management",
                    name: "poboPayerManagement",
                    meta: {
                        loginAuth: true,
                        title: "poboPayerManagement",
                    },
                    component: PoboPayerManagement,
                    children: [],
                },
                {
                    path: "/payment/payer-management/add",
                    name: "poboPayerForm",
                    meta: {
                        loginAuth: true,
                        title: "poboPayerForm",
                    },
                    component: PoboPayerForm,
                    children: [],
                },
                {
                    path: "/transfer",
                    name: "accountTransfer",
                    meta: {
                        loginAuth: true,
                        title: "accountTransfer",
                    },
                    component: AccountTransfer,
                    children: [],
                },
                {
                    path: "/payment/bulk",
                    name: "bulkPayment",
                    meta: {
                        loginAuth: true,
                        title: "bulkPayment",
                    },
                    component: BulkPayment,
                    children: [],
                },
                {
                    path: "/sub/payment/bulk",
                    name: "subBulkPayment",
                    meta: {
                        loginAuth: true,
                        title: "subBulkPayment",
                    },
                    component: SubBulkPayment,
                    children: [],
                },
                {
                    path: "/payeeAccount",
                    name: "payeeAccount",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "payeeAccount",
                    },
                    component: PayeeAccount,
                    children: [],
                },
                {
                    path: "/payeeAccount/batchImport",
                    name: "batchPayeeImport",
                    meta: {
                        loginAuth: true,
                        title: "payeeAccount",
                    },
                    component: BatchPayeeImport,
                },
                {
                    path: "/PayeeAccountByUser",
                    name: "PayeeAccountByUser",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "PayeeAccountByUser",
                    },
                    component: PayeeAccountByUser,
                    children: [],
                },

                {
                    path: "/kyc/list",
                    name: "实名验证",
                    meta: {
                        title: "实名验证",
                    },
                    component: KycList,
                    children: [],
                },
                {
                    path: "/payee",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "payee",
                    },
                    component: PayeeIndex,
                    children: [{
                        path: "/payee",
                        name: "payee",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "payee",
                        },
                        component: Payee,
                        children: [],
                    },
                    {
                        path: "/applyPayeeAccount",
                        redirect: {
                            path: "/applyShopAccount",
                            query: { platformId: "COLLECTION" }
                        }
                    },
                    {
                        path: "/applyShopAccount",
                        name: "applyShopAccount",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "applyShopAccount",
                        },
                        component: ApplyShopAccount,
                        children: [],
                    },
                    {
                        path: "/bindShop",
                        name: "bindShop",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "bindShop",
                        },
                        component: BindShop,
                        children: [],
                    },
                    {
                        path: "/bindShopVinted",
                        name: "bindShopVinted",
                        meta: {
                            loginAuth: true,
                            title: "bindShopVinted",
                        },
                        component: BindShopVinted,
                        children: [],
                    },
                    {
                        path: "/bindOther",
                        name: "bindOther",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "bindOther",
                        },
                        component: BindOther,
                        children: [],
                    },
                    {
                        path: "/businessOpenRecord",
                        name: "businessOpenRecord",
                        meta: {
                            loginAuth: true,
                            title: "businessOpenRecord",
                            enterpriseOnly: true,
                        },
                        component: BusinessOpenRecord,
                        children: [],
                    },
                    {
                        path: "/businessOpenRecord/detail",
                        name: "businessOpenRecordDetail",
                        meta: {
                            loginAuth: true,
                            title: "businessOpenRecordDetail",
                            enterpriseOnly: true,
                        },
                        component: BusinessOpenRecordDetail,
                        children: [],
                    },
                    {
                        path: "/shopListVinted",
                        name: "shopListVinted",
                        meta: {
                            loginAuth: true,
                            title: "shopListVinted",
                        },
                        component: ShopListVinted,
                        children: [],
                    },

                    {
                        path: "/myShop",
                        name: "myShop",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "myShop",
                        },
                        component: MyShop,
                        children: [],
                    },
                    {
                        path: "/myShopOther",
                        name: "myShopOther",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "myShopOther",
                        },
                        component: MyShopOther,
                        children: [],
                    },
                    {
                        path: "/shopOrderList",
                        name: "shopOrderList",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "shopOrderList",
                        },
                        component: ShopOrderList,
                        children: [],
                    },
                    {
                        path: "/shopOrderListByEntity",
                        name: "shopOrderListByEntity",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "shopOrderListByEntity",
                        },
                        component: ShopOrderListByEntity,
                        children: [],
                    },
                    {
                        path: "/vaList",
                        name: "vaList",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "vaList",
                        },
                        component: () =>
                            import("../components-new/payee/vaList.vue"),
                        children: [],
                    },
                    {
                        path: "/shopHolderManage",
                        name: "shopHolderManage",
                        meta: {
                            loginAuth: true,
                            title: "shopHolderManage",
                        },
                        component: () =>
                            import("../components-new/payee/shopHolderManage.vue"),
                        children: [],
                    },
                    {
                        path: "/shopHolderManage/add",
                        name: "shopHolderManageAdd",
                        meta: {
                            loginAuth: true,
                            title: "shopHolderManageAdd",
                        },
                        component: () =>
                            import("../components-new/payee/shopHolderAdd.vue"),
                        children: [],
                    },
                    {
                        path: "/shopHolderManage/detail",
                        name: "shopHolderManageDetail",
                        meta: {
                            loginAuth: true,
                            title: "shopHolderManageDetail",
                        },
                        component: () =>
                            import("../components-new/payee/shopHolderDetail.vue"),
                        children: [],
                    },
                    {
                        path: "/shopManage",
                        name: "shopManage",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "shopManage",
                        },
                        component: () =>
                            import("../components-new/payee/shopManage/index.vue"),
                        children: [],
                    },
                    ],
                },
                {
                    path: "/exchange",
                    name: "exchange",
                    meta: { loginAuth: true, title: "exchange" },
                    component: () => import("../components-new/exchange/Exchange.vue"),
                },
                {
                    path: "/tradeSeach",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "tradeSeach",
                    },
                    component: TradeSeach,
                    children: [{
                        path: "/tradeSeach",
                        name: "tradeSeach",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "tradeSeach",
                        },
                        component: TradeDetail,
                        children: [],
                    },
                    {
                        path: "/tradeReceipt",
                        name: "tradeReceipt",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "tradeReceipt",
                        },
                        component: TradeReceipt,
                        children: [],
                    },
                    {
                        path: "/balanceDetail",
                        name: "balanceDetail",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "balanceDetail",
                        },
                        component: BalanceDetail,
                        children: [],
                    },
                    {
                        path: "/cashDetail",
                        name: "cashDetail",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "cashDetail",
                        },
                        component: CashDetail,
                        children: [],
                    },
                    {
                        path: "/batchDetail",
                        name: "batchDetail",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "batchDetail",
                        },
                        component: batchDetail,
                        children: [],
                    },

                    {
                        path: "/myBill",
                        name: "myBill",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "myBill",
                        },
                        component: MyBill,
                        children: [],
                    },
                    ],
                },
                {
                    path: "/userSettings",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "userSettings",
                    },
                    component: () =>
                        import("../components-new/personalCenter/index.vue"),
                    children: [{
                        path: "/userSettings",
                        name: "userSettings",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "userSettings",
                        },
                        component: () =>
                            import("../components-new/personalCenter/userSettings/userSettings.vue"),
                        children: [],
                    },
                    {
                        path: "/customerManager",
                        name: "customerManager",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "customerManager",
                        },
                        component: () =>
                            import("../components-new/personalCenter/customerManager/customerManager.vue"),
                        children: [],
                    },
                    {
                        path: "/accountHolderManager",
                        name: "accountHolderManager",
                        meta: {
                            loginAuth: true, // 需要登录验证的页面添加meta属性
                            title: "accountHolderManager",
                        },
                        component: () =>
                            import("../components-new/personalCenter/accountHolderManager/accountHolderManager.vue"),
                    },
                    {
                        path: "/subAccountManager",
                        name: "subAccountManager",
                        meta: {
                            loginAuth: true,
                            title: "subAccountManager",
                        },
                        component: () =>
                            import("../components-new/personalCenter/subAccountManager/subAccountManager.vue"),
                    },
                    ],
                },
                {
                    path: "/quota",
                    name: "quota",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "quota",
                    },
                    component: () =>
                        import("../components-new/quota/index.vue"),
                    children: [

                    ],
                },
                {
                    path: "/quotaDetail",
                    name: "quotaDetail",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "额度详情",
                    },
                    component: () =>
                        import("../components-new/quota/quotaDetail.vue"),
                    children: [],
                }
            ],
        },
        /** 店铺绑定 */
        {
            path: "/shopBinding",
            name: "店铺绑定",
            meta: {
                loginAuth: false,
                title: "",
            },
            component: () =>
                import("../components-new/shopBinding/layout/layout.vue"),
            children: [
                /** 账户关联绑定-loading页面 */
                {
                    path: "/shopBinding/loading",
                    name: "shopBinding_loading",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "账户关联",
                    },
                    component: () =>
                        import("../components-new/shopBinding/loading/loading"),
                },
                /** 账户关联绑定-登录页面 */
                {
                    path: "/shopBinding/signin",
                    name: "shopBinding_signin",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-登录",
                    },
                    component: login,
                },
                /** 账户关联绑定-注册页面 */
                {
                    path: "/shopBinding/signup",
                    name: "shopBinding_signup",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-注册",
                    },
                    component: register,
                },
                /** 账户关联绑定-超时页面 */
                {
                    path: "/shopBinding/expiredPage",
                    name: "shopBinding_expiredPage",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-超时",
                    },
                    component: () =>
                        import("../components-new/shopBinding/expiredPage/expiredPage"),
                },
                /** 账户关联绑定-kyc状态页面 */
                {
                    path: "/shopBinding/kycStatusPage",
                    name: "shopBinding_kycStatusPage",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-实名状态",
                    },
                    component: () =>
                        import("../components-new/shopBinding/kycStatusPage/kycStatusPage"),
                },
                /** 账户关联绑定-预绑定完成 */
                {
                    path: "/shopBinding/preBindingComplete",
                    name: "shopBinding_preBindingComplete",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-预绑定完成",
                    },
                    component: () =>
                        import(
                            "../components-new/shopBinding/preBindingComplete/preBindingComplete"
                        ),
                },
                /** 账户关联绑定-直接绑定结果页面 */
                {
                    path: "/shopBinding/directBindingResult",
                    name: "shopBinding_directBindingResult",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-绑定结果",
                    },
                    component: () =>
                        import(
                            "../components-new/shopBinding/directBindingResult/directBindingResult"
                        ),
                },
                /** 账户关联绑定-绑定完成页面 */
                {
                    path: "/shopBinding/bindComplete",
                    name: "shopBinding_bindComplete",
                    meta: {
                        loginAuth: false, // 需要登录验证的页面添加meta属性
                        title: "账户关联-绑定完成",
                    },
                    component: () =>
                        import("../components-new/shopBinding/bindComplete/bindComplete"),
                },
                /** 账户关联绑定-切换账户页面 */
                {
                    path: "/shopBinding/changeAccount",
                    name: "shopBinding_changeAccount",
                    meta: {
                        loginAuth: true, // 需要登录验证的页面添加meta属性
                        title: "账户关联-切换账户",
                    },
                    component: () =>
                        import("../components-new/shopBinding/changeAccount/changeAccount"),
                },
            ],
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { left: 0, top: 0 }
    }
});

const disposeNavigationFeedback = installNavigationFeedback(router);
if (import.meta.hot) import.meta.hot.dispose(disposeNavigationFeedback);

let latestNavigationTarget;

// 路由拦截，判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
    latestNavigationTarget = to.fullPath;
    const pageRecord = to.matched[to.matched.length - 1];
    const pageMeta = (pageRecord ? pageRecord.meta : to.meta) || {};
    // 已登录时，每次路由切换异步刷新 profile 缓存（不阻塞 next）
    refreshProfileCache();

    // 如果访问的页面，有source参数，表示携带了注册来源，需要保存在store里，在注册的时候读取
    if (to.query && to.query.source) {
        store.commit("app/setRegisterSource", to.query.source);
    }
    if (to.query && to.query.sc) {
        store.commit("app/setSaleCode", to.query.sc);
    }
    const shopBindingPath = [
        "/shopBinding/loading",
        "/shopBinding/signin",
        "/shopBinding/signup",
        "/shopBinding/expiredPage",
        "/shopBinding/kycStatusPage",
        "/shopBinding/preBindingComplete",
        "/shopBinding/directBindingResult",
        "/shopBinding/bindComplete",
        "/shopBinding/changeAccount",
    ];
    let permission = false;

    // 白名单路径不需要校验token
    const whiteList = [
        "/register",
        "/resetPwd",
        "/registerFile",
        "/forgetPassword",
        "/user",
        "agreement",
        "authorize",
        "/userSettings",
        "/customerManager",
        "/accountHolderManager",
        "/subAccountManager",
        "/creatVa",
    ];

    // 检查是否在白名单中
    const isInWhiteList = (path) => {
        return whiteList.some(item => path.includes(item)) || pageMeta.loginAuth === false;
    }
    const isInbindWhiteList = (path) => {
        return shopBindingPath.some(item => path.includes(item)) || pageMeta.loginAuth === false;
    }

    if (
        isSubUserSession() &&
        !shouldSkipSubUserRouteGuard(to.path) &&
        !canSubUserAccessPath(to.path)
    ) {
        return next(getSubUserLandingPath());
    }

    // 如果在白名单中，直接放行
    if (isInWhiteList(to.path) || isInbindWhiteList(to.path)) {
        return next();
    }

    // 增加本地token校验
    const localToken = (sessionStorage.loginData && sessionStorage.loginData != 'null') ? JSON.parse(sessionStorage.loginData).accessToken : ''
    const role = sessionStorage.loginData && sessionStorage.loginData != "null" ? JSON.parse(sessionStorage.loginData).accessToken : "";
    let entityInfo = sessionStorage.getItem("entityData") && sessionStorage.getItem("entityData") != "null" ? JSON.parse(sessionStorage.getItem("entityData")) : "";


    // 没有token且不是登录页面，跳转到登录页
    if (!role && !localToken) {
        return next("/login");
    }

    if (
        to.matched.some(record => record.meta && record.meta.enterpriseOnly) &&
        entityInfo &&
        entityInfo.entityType === "PERSONAL"
    ) {
        ElMessage({
            type: "warning",
            message: i18n.t("LANG.page403.a1"),
        });
        return next("/payee");
    }

    // 其他情况继续原有逻辑
    if (to.path == "/payment/transferList/bookSingleTransfer") {
        localStorage.bookSingleTransfer = JSON.stringify(window.location);
    }
    // 如果是店铺绑定页面的loading页面，就跳转到店铺绑定的登录页面
    if (to.path === "/shopBinding/loading") {
        return next({
            path: "/shopBinding/signin",
            query: {
                ...to.query,
            },
        });
    }
    if (to.path !== '/applyKyc') {
        // i18n.locale = 'zh-CN'
        window.$eventBus.$emit('changeLang')
    }
    // else if (!permission && to.path !== '/403' && to.path !== '/login') {
    //     next('/403');
    // }

    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf("MSIE") > -1 && to.path === "/editor") {
        ElMessageBox.alert(i18nTip(localStorage.lang), {
            confirmButtonText: "确定",
        });
    } else {
        // to.path !== "/userSettings" && 暂时注释允许进入个人中心
        const isSubUser = isSubUserSession() || isPendingSubUserLogin();
        if (
            entityInfo.status !== "ACTIVATED" &&
            entityInfo.status !== "FROZEN" &&
            !isSubUser &&
            to.path !== "/kyc/list" &&
            to.path !== "/login" &&
            to.path !== "/home" &&
            to.path !== "/applyKyc" &&

            !shopBindingPath.includes(to.path)
        ) {
            // 未通过审核的用户，不能进入除了实名认证页面以外的页面
            // 页面path 等于login的情况下不触发提示
            if (to.path !== '/login' && from.path !== '/login') {
                ElMessage({
                    type: "warning",
                    message: i18n.t('LANG.router.kycRequired'),
                });
            }
            setTimeout(() => {
                next({
                    path: "/kyc/list",
                });
            }, 200);
        } else {
            if (!isSubUser && (!entityInfo || !entityInfo.entityId)) {
                getCurrentEntityInfo().then(res => {
                    if (res && res.data && res.data.entityId) {
                        sessionStorage.setItem("entityData", JSON.stringify(res.data));
                    }
                    sessionStorage.setItem('firstLogin', true);
                }).catch(error => {
                    console.log(error);
                    sessionStorage.setItem('firstLogin', true);
                });
            } else {
                sessionStorage.setItem('firstLogin', true);
            }
            next();
        }
    } // else if (to.meta.permission) {
    //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //     role === 'admin' ? next() : next('/403');
    // }
});




const retriedImports = new Set();

router.onError((error, to) => {
    const isImportFailure = /Loading (?:CSS )?chunk .*failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(error && error.message || "");
    const targetPath = to && to.fullPath;
    if (isImportFailure) checkForAppUpdate();
    if (isImportFailure && targetPath && targetPath === latestNavigationTarget && !retriedImports.has(targetPath)) {
        retriedImports.add(targetPath);
        router.replace(targetPath).catch(() => {});
        return;
    }
    console.error(error);
});

export default router;
